import React, { useContext } from 'react';
import Avatar from 'components/ui/Avatar';

import UserRoleSelect from './UserRoleSelect';
import DotMenu from 'components/ui/DotMenu';
import DotMenuItem from 'components/ui/DotMenuItem';

import { FaTrash, FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import AuthContext from 'providers/auth';
import UserApi from 'api/user';

const UserCard = user => {
  const currentUserContext = useContext(AuthContext);
  const { t } = useTranslation();

  const { id: currentCompanyId } = currentUserContext.me.company;
  const { is_holder: currentUserIsHolder } = currentUserContext.me;
  const { is_admin: currentUserIsAdmin } = currentUserContext.me.company;
  const { is_admin } = user.companies.find(company => company.id === currentCompanyId).UserCompany;

  const default_roles = user.roles.map(role => {
    return {
      value: role.id,
      label: role.name,
      ...role,
    };
  });

  const AdminStar = () => {
    const currentUserIsElevated = currentUserIsAdmin || currentUserIsHolder;
    const color = is_admin ? '#FFD700' : '#DDDDDD';
    const cursor = currentUserIsElevated ? 'cursor-pointer' : 'cursor-not-allowed';

    const type = is_admin ? 'remove' : 'make';
    const title = currentUserIsElevated ? t(`actions.${type}_admin`) : '';
    const onClick = currentUserIsElevated ? user.toggleAdmin : null;

    return (
      <>
        <div className={`position-absolute start-5 top-5 ${cursor}`} onClick={onClick} title={title}>
          <FaStar color={color} />
        </div>
      </>
    );
  };

  return (
    <div className="card border-0 shadow-sm position-relative">
      <AdminStar />
      <div className="card-body text-center">
        <Avatar name={user.name} email={user.email} src={user.profile_image} size={80} className="shadow-sm rounded-circle mb-3" />
        <h5 className="fw-normal mt-0 mb-0 text-truncate">{user.name}</h5>
        <p className="mt-0 mb-0 text-truncate">{user.email}</p>
      </div>

      <div className="card-footer">
        <div className="d-flex align-items-center">
          <UserRoleSelect className="tag-select flex-fill w-100" defaultValue={default_roles} user={user} />

          <DotMenu>
            <DotMenuItem onClick={user.remove} type="button">
              <div className="d-flex align-items-center p-1 text-danger">
                <FaTrash /> <div className="ms-2">{t('actions.remove')}</div>
              </div>
            </DotMenuItem>
          </DotMenu>
        </div>
      </div>
    </div>
  );
};

const fetchUserData = async id => UserApi.getMe(id);
export default UserCard;
